import { retroComputersVaultType } from './retroComputers.js';
import { retroAudioVaultType } from './retroAudio.js';
import { vintageCamerasVaultType } from './vintageCameras.js';
import { watchesVaultType } from './watches.js';
export const VAULT_TYPES = [
    'retro_computers',
    'retro_audio',
    'vintage_cameras',
    'watches',
];
/** Check whether a vault type string is a built-in type. */
export function isBuiltInVaultType(id) {
    return VAULT_TYPES.includes(id);
}
/** Check whether a vault type string is a custom type. */
export function isCustomVaultType(id) {
    return id.startsWith('custom_');
}
// ---------------------------------------------------------------------------
// Built-in vault type registry
// ---------------------------------------------------------------------------
const vaultTypeRegistry = {
    retro_computers: retroComputersVaultType,
    retro_audio: retroAudioVaultType,
    vintage_cameras: vintageCamerasVaultType,
    watches: watchesVaultType,
};
export function getVaultType(id) {
    const def = vaultTypeRegistry[id];
    if (!def)
        throw new Error(`Unknown vault type: ${id}`);
    return def;
}
export function getAllVaultTypes() {
    return VAULT_TYPES.map((id) => vaultTypeRegistry[id]);
}
// ---------------------------------------------------------------------------
// Build a VaultTypeDefinition at runtime from a custom vault definition
// ---------------------------------------------------------------------------
const CONDITIONS = ['mint', 'excellent', 'good', 'fair', 'poor', 'parts'];
export function buildCustomVaultTypeDef(vaultType, def) {
    const fieldNames = def.fields.map((f) => f.label).join(', ');
    const aiPrompt = `You are an expert at identifying items in a "${def.displayName}" collection. ` +
        `The collector describes this vault as: ${def.description} ` +
        `They track these attributes: ${fieldNames}. ` +
        `Analyze the image and extract as many of these fields as you can identify. ` +
        `Also suggest a category and brand/maker if applicable.`;
    return {
        id: vaultType,
        label: def.displayName,
        tagline: def.description.length > 80 ? def.description.slice(0, 77) + '...' : def.description,
        icon: def.icon,
        platformLabel: def.platformLabel || 'Brand',
        categories: [],
        brands: [],
        brandModels: {},
        categoryBrands: {},
        subcategories: {},
        conditions: CONDITIONS,
        specializedFields: def.fields.map((f) => ({
            key: f.key,
            label: f.label,
            type: f.type,
            placeholder: f.placeholder,
            options: f.options,
        })),
        specializedFeatures: {},
        aiSystemPrompt: aiPrompt,
        maintenanceAlertTypes: ['custom'],
        fileTypes: ['manual_pdf', 'other'],
        defaultThemes: ['vivid', 'modern_dark', 'modern_light'],
    };
}
export { retroComputersVaultType } from './retroComputers.js';
export { retroAudioVaultType } from './retroAudio.js';
export { vintageCamerasVaultType } from './vintageCameras.js';
export { watchesVaultType } from './watches.js';
//# sourceMappingURL=index.js.map